import styled from "styled-components";

export const DatePickersContainer = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 1rem;
`;

export const FilterButtonInnerContainer = styled.div`
	display: flex;
	gap: 0.4rem;
	align-items: center;
	justify-content: center;
`;
